import React, { Component } from "react"

//material ui
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Button from "@material-ui/core/Button"
import DoneIcon from "@material-ui/icons/Done"
import Avatar from "@material-ui/core/Avatar"
import PropTypes from "prop-types"
import withStyles from "@material-ui/core/styles/withStyles"
import { ThankyousignupStyle } from "../Style/ThankyousignupStyle"

class Thankyousignup extends Component {
	render() {
		const { Open, handleClickClose, t, classes } = this.props
		return (
			<Dialog
				open={Open}
				onClose={handleClickClose}
				fullWidth
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="scroll-dialog-title" className={classes.paper}>
					<Avatar className={classes.avatar}>
						<DoneIcon />
					</Avatar>

					{t("NotificationManager.Login.Thankyou")}
				</DialogTitle>
				<DialogContent>
					<DialogContentText style={{ color: "#000" }}>
						{t("NotificationManager.Login.Thankyousignup")}
						<br />
						<br />
						{t("NotificationManager.Login.Thankyousignup1")}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						aria-label="handleClickClose"
						onClick={handleClickClose}
						color="primary"
						style={{ textTransform: "none" }}
					>
						{t("button.buttonclose")}
					</Button>
				</DialogActions>
			</Dialog>
		)
	}
}

Thankyousignup.propTypes = {
	classes: PropTypes.object.isRequired
}
export default withStyles(ThankyousignupStyle)(Thankyousignup)
